import styled from 'styled-components';
import top_bg from '../../../assets/image/top_bg.png';
import {bdAll1px} from '../../../utils/style/mixin';

const Container = styled.div`
width: 100%;
background: #fff;
overflow: hidden;
.vendor{
  position: relative;
  top: -.02rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(https://m.360buyimg.com/img/jfs/t1/145736/8/24123/8270/62ac4c74E3929de17/e1bb8de38c23756d.png);
  background-color:#fff;
  padding-bottom:1.8rem;
}
.vendor-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: .416rem .36rem;
  box-sizing: border-box;
}
.vendor-logowrap {
  height: 1.2rem;
}
.vendor-logowrap--default {
  height: 1.2rem;
  overflow: hidden;
}
.vendor-logo {
  width: auto;
  height: 1.2rem;
  border-radius: 50%;
}
.vendor-logo[src=''] {
  opacity: 0;
}
.vendor-name {
  font-size: .36rem;
  color: #fff;
  font-weight: bold;
  line-height: .516rem;
  margin-top: .15rem;
}
.vendor-orgs {
  margin-top: .15rem;
}
.vendor-org {
  line-height: .416rem;
  color: #C71622;
  font-size: .24rem;
  padding: .02rem .2rem;
  margin-right: .2rem;
  white-space: nowrap;
  border: .01rem solid #fff;
  border-radius: .4rem;
  background: linear-gradient(90deg, rgba(255,237,212,1) 0%,rgba(218,187,153,1) 100%),linear-gradient(180deg, rgba(255,249,239,1) 0%,rgba(255,231,188,1) 99.61210664335664%),linear-gradient(rgba(199,22,34,1), rgba(199,22,34,1));
  opacity: 99;
}
.vendor-categorys{
  font-size: .26rem;
  color: #fff;
  padding-top: .2rem;
  line-height: 1.2;
}
.products {
  display: flex;
  flext-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 .36rem;
  border-radius: .08rem;
  background: rgba(0,0,0,0.02);
  margin-top: -2rem;
  position: relative;
}
.products1 {
  justify-content: center;
}
.product {
  margin-top: .15rem;
  border-radius: .08rem;
  overflow: hidden;
}
.product1 {
  width: 100%;
  height: 100%;
}
.product2 {
  width: 3.27rem;
  height: 2.18rem;
}
.product3 {
  width: 3.27rem;
  height: 2.18rem;
}
.product-img {
  width: 100%;
  height: 100%;
  background: #fff;
}
.more {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: .36rem;
  background-color: rgba(0,0,0,0.02);
  background-image: url(https://m.360buyimg.com/img/jfs/t1/62979/15/19647/3488/62cf761aEbfd7f1c1/c5b66d7d904d993e.png);
  background-repeat: no-repeat;
  background-position: right;
  background-size: 3rem;
}
.more-left {}
.more-text1 {
  font-size: .28rem;
  color: #000;
  line-height: .4rem;
  margin-top: .18rem;
}
.more-text2 {
  font-size: .2rem;
  color: rgba(0,0,0,0.45);
  line-height: .28rem;
}
.more-img {
  width: 2.5rem;
  height: auto;
  margin-top: .1rem;
}
.more-right {}
.more-qrcode {
  width: 1.77rem;
  height: 1.77rem;
}
`;

export {
  Container,
}
